<form [formGroup]="formGroup" class="bdi">
  @for (element of elements; track element.name; let i = $index) {
    @if (element.type === "radiogroup") {
      <div class="bdi-row">
        <div class="bdi-q">
          <div class="bdi-q-title">{{ i + 1 }}. {{ element.title }}</div>
        </div>

        <div class="bdi-a">
          <div class="bdi-group">
            @for (choice of element.choices; track choice.value) {
              <label class="q-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="bdi-option-text">{{ choice.text }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    }
  }

</form>
